export interface NavItem {
  navCap?: string;
  displayName?: string;
  iconName?: string;
  route?: string;
  permissions?: string[];
  isReactRoute?: boolean; // Nova propriedade para definir se é rota do React
}

export const navItems: NavItem[] = [
  {
    navCap: 'Menu',
  },
  {
    displayName: 'Home',
    iconName: 'home',
    route: '/home',
    permissions: ['revendedora', 'coordenadora'],
    isReactRoute: true,
  },
  // {
  //   displayName: 'Home',
  //   iconName: 'home',
  //   route: '/painel/home',
  //   permissions: ['admin'],
  // },  
  {
    displayName: 'Home [V2]',
    iconName: 'home',
    route: '/',
    permissions: [ 'admin'],
    isReactRoute: true,
  },
  {
    displayName: 'Home',
    iconName: 'home',
    route: '/home-cliente',
    permissions: [ 'cliente'],
    isReactRoute: true,
  },
  // {
  //   displayName: 'Usuários',
  //   iconName: 'users-group',
  //   route: '/painel/users',
  //   permissions: ['admin'],
  // },
  {
    displayName: 'Usuários [V2]',
    iconName: 'users-group',
    route: '/usuarios',
    permissions: ['admin'],
    isReactRoute: true,
  },
  // {
  //   displayName: 'Diamantes',
  //   iconName: 'gem',
  //   route: '/diamantes',
  //   permissions: ['admin', 'coordenadora', 'revendedora', 'cliente'],
  //   isReactRoute: true,
  // },
  {
    displayName: 'Loja de Recompensas',
    iconName: 'gem',
    route: '/loja-recompensas',
    permissions: ['admin', 'coordenadora', 'revendedora', 'cliente'],
    isReactRoute: true,
  },
  {
    displayName: 'Ranking Vendas',
    iconName: 'trophy',
    route: '/ranking-vendas',
    permissions: ['admin', 'coordenadora', 'revendedora'],
    isReactRoute: true
  },
  {
    displayName: 'Nova Venda',
    iconName: 'currency-dollar',
    route: '/nova-venda',
    permissions: ['admin', 'coordenadora', 'revendedora'],
    isReactRoute: true, // Esta rota agora aponta para o React
  },    
  {
    displayName: 'Meus Pedidos',
    iconName: 'shopping-bag',
    route: '/pedidos',
    permissions: ['cliente'],
    isReactRoute: true,
  },
  // {
  //   displayName: 'Meus Cupons',
  //   iconName: 'ticket',
  //   route: '/meus-cupons',
  //   permissions: ['cliente','revendedora'],
  //   isReactRoute: true,
  // },
  {
    displayName: 'Minha Rede',
    iconName: 'users-group',
    route: '/minha-rede',
    permissions: ['admin', 'coordenadora', 'revendedora', 'cliente'],
    isReactRoute: true,
  },  
  {
    displayName: 'Suporte',
    iconName: 'message-square-heart',
    route: '/suporte',
    permissions: ['cliente'],
    isReactRoute: true,
  },  
  {
    displayName: 'Minhas Vendas',
    iconName: 'receipt-2',
    route: '/minhas-vendas',
    permissions: ['admin', 'coordenadora', 'revendedora'],
    isReactRoute: true,
  },
  {
    displayName: 'Relatórios Vendas [V2]',
    iconName: 'report-money',
    route: '/relatorios-vendas',
    permissions: ['admin'],
    isReactRoute: true,
  },
  {
    displayName: 'Garantias',
    iconName: 'shield-check',
    route: '/garantias',
    permissions: ['admin', 'coordenadora', 'revendedora'],
    isReactRoute: true,
  },
  {
    displayName: 'Vendas Falhas',
    iconName: 'coin-off',
    route: '/painel/vendas-falhas',
    permissions: ['admin'],
  },
  {
    displayName: 'Minhas Revendedoras',
    iconName: 'users-group',
    route: '/painel/minhas-revendedoras',
    permissions: ['coordenadora'],
  },
  {
    displayName: 'Todas Revendedoras',
    iconName: 'users-group',
    route: '/painel/todas-revendedoras',
    permissions: ['admin'],
  },
  // {
  //   displayName: 'Pré Cadastros',
  //   iconName: 'user-pentagon',
  //   route: '/painel/pre-cadastros',
  //   permissions: ['admin', 'coordenadora', 'matriz'],
  // },
  {
    displayName: 'Pré-Cadastros [V2]',
    iconName: 'user-pentagon',
    route: '/pre-cadastros',
    permissions: ['admin', 'coordenadora', 'matriz'],
    isReactRoute: true,
  },  
  {
    displayName: 'Cadastros Pendentes',
    iconName: 'users-plus',
    route: '/painel/cadastros-pendentes',
    permissions: ['admin', 'coordenadora'],
  },
  {
    navCap: 'Cupons',
    permissions: ['admin'],
  },
  {
    displayName: 'Cupons & Sorteios',
    iconName: 'ticket',
    route: '/admin-cupons',
    permissions: ['admin'],
    isReactRoute: true,
  },
  {
    navCap: 'Multinível',
    permissions: ['admin'],
  },
  {
    displayName: 'Recibos',
    iconName: 'receipt-2',
    route: '/recibos-multinivel',
    permissions: ['admin'],
    isReactRoute: true,
  },
  {
    navCap: 'Franquias',
    permissions: ['admin', 'matriz'],
  },
  {
    displayName: 'Gerenciar Franquias',
    iconName: 'certificate-2',
    route: '/painel/franquias',
    permissions: ['admin', 'matriz'],
  },
  {
    displayName: 'Resgates Franquias',
    iconName: 'diamond',
    route: '/painel/resgates-franquias',
    permissions: ['admin', 'matriz'],
  },
  {
    navCap: 'Programa Diamantes',
    permissions: ['admin'],
  },
  {
    displayName: 'Dados Prog. Diamantes',
    iconName: 'device-desktop-analytics',
    route: '/painel/diamantes/acompanhamento',
    permissions: ['admin'],
  },
  {
    displayName: 'Adesões Prog. Diamantes',
    iconName: 'certificate-2',
    route: '/painel/diamantes/adesoes',
    permissions: ['admin'],
  },
  // {
  //   displayName: 'Resgates de Diamantes',
  //   iconName: 'diamond',
  //   route: '/painel/diamantes/resgates',
  //   permissions: ['admin'],
  // },
  {
    displayName: 'Resgates [V2]',
    iconName: 'gem',
    route: '/relatorios-resgates',
    permissions: ['admin'],
    isReactRoute: true,
  },
  {
    displayName: 'Itens de Resgate [V2]',
    iconName: 'gift',
    route: '/gerenciamento-itens',
    permissions: ['admin', 'matriz'],
    isReactRoute: true,
  },
  {
    displayName: 'Extratos Diamantes',
    iconName: 'file-invoice',
    route: '/painel/diamantes/extratos/admin',
    permissions: ['admin', 'matriz'],
  },
  {
    navCap: 'Admin',
    permissions: ['admin'],
  },
  {
    displayName: 'Push Notifications',
    iconName: 'send',
    route: '/admin-push-notifications',
    permissions: ['admin'],
    isReactRoute: true,
  },
   {
      displayName: 'Todas Notificações',
    iconName: 'bell',
    route: '/admin-all-notifications',
    permissions: ['admin'],
    isReactRoute: true,
  },
  {
    displayName: 'Configurações',
    iconName: 'settings',
    route: '/painel/configuracoes',
    permissions: ['admin'],
  },
  {
    displayName: 'Logs Sistema',
    iconName: 'bug',
    route: '/painel/logs',
    permissions: ['admin'],
  },
];
